import {Space} from "antd";
import {CustomerServiceOrders} from "../../../../../components/store/services/orders/customer";

export function CustomerServicesEntryPoint() {
  return (
    <div>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <CustomerServiceOrders />
      </Space>
    </div>
  );
}
